// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1jBo1","footer":"ModalError_footer___C1yl"};